<template>
  <div class="container mescroll-touch">
    <!-- <img src="../../assets/images/acmedtopback.png" class="img" /> -->
    <!-- <img src="../../assets/images/ccdsgg.png" class="guanggaoimg" /> -->
    <el-carousel :interval="5000" arrow="always" class="elbanner">
      <el-carousel-item v-for="item in bannerlist" :key="item">
        <img :src="item.ImgUrl" class="bannerimg" @click="jumpimgurl(item.LinkUrl, item.Id, item.Description)" />
      </el-carousel-item>
    </el-carousel>
    <div class="btnlist">
      <div class="btnrow">
        <div class="btnsimple">
          <div class="btnincolnew">
            <div class="btnsmall1">
              <div class="btnsmall2 btnheng">
                <!-- <img src="../../assets/images/xximg.png" class="btnmimg3" /> -->
                <div class="timem" v-if="isopen == 0">距大会开幕式还有</div>
                <div class="timem" v-if="isopen == 0"><span class="timel">{{ day }}</span>天</div>
                <div class="timem" v-if="isopen == 1"><span class="timel">大会已开始！</span></div>
                <div class="times" v-if="isopen == 0">
                  <div class="bold">{{ hh }}</div>时<div class="bold">{{ mm }}</div>分<div class="bold">{{ ss }}</div>秒
                </div>
                <!-- <div class="btntext2">基本<br />信息</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btnrow">
        <div class="btnmiddle" @click="gowelcome()">
          <div class="btntext">欢迎辞</div>
          <div class="btntext btnhide1">/</div>
          <div class="btnimgout">
            <img src="../../assets/images/ccdswelimg.png" class="btnmimg" />
          </div>
        </div>
        <div class="btnlarge" @click="goregmeeting()">
          <div class="btntext1">注册及缴费</div>
          <div class="btntext btnhide1">/</div>
          <div class="btnimgout">
            <img src="../../assets/images/ccdsjfimg.png" class="btnmimg1" />
          </div>
        </div>
      </div>

      <div class="btnrow">
        <div class="btn50 left50" @click="goinfo()">
          <div class="btntext2">会议信息</div>
          <div class="btntext btnhide">/</div>
          <div class="btnimgout">
            <img src="../../assets/images/ccdsxximg.png" class="btnmimg2" />
          </div>
        </div>
        <div class="btn50" @click="gotimeline()">
          <div class="btntext2">会议日程</div>
          <div class="btntext btnhide">/</div>
          <div class="btnimgout">
            <img src="../../assets/images/ccdstimeimg.png" class="btnmimg2" />
          </div>
        </div>
      </div>

      <div class="btnrow">
        <div class="btn50 left50" @click="gojiaotong()">
          <div class="btntext2">交通住宿</div>
          <div class="btntext btnhide">/</div>
          <div class="btnimgout">
            <img src="../../assets/images/ccdsjtimg.png" class="btnmimg2" />
          </div>
        </div>
        <div class="btn50" @click="gojoinme()">
          <div class="btntext2">注意事项</div>
          <div class="btntext btnhide">/</div>
          <div class="btnimgout">
            <img src="../../assets/images/ccdszyimg.png" class="btnmimg2" />
          </div>
        </div>
      </div>

      <div class="btnrow">
        <div class="btn50 left50" @click="goToExternalLink()">
          <div class="btntext2">征文投稿</div>
          <div class="btntext btnhide">/</div>
          <div class="btnimgout">
            <img src="../../assets/images/ccdszwimg.png" class="btnmimg2" />
          </div>
        </div>
        <div class="btn50" @click="godownfile()">
          <div class="btntext2">下载专区</div>
          <div class="btntext btnhide">/</div>
          <div class="btnimgout">
            <img src="../../assets/images/ccdsdownloadimg.png" class="btnmimg2" />
          </div>
        </div>
      </div>

      <div class="btnrow">
        <div class="btn50 left50" @click="gozuzhi()">
          <div class="btntext2">组织架构</div>
          <div class="btntext btnhide">/</div>
          <div class="btnimgout">
            <img src="../../assets/images/ccdszzimg.png" class="btnmimg2" />
          </div>
        </div>
        <div class="btn50" @click="gozb()">
          <div class="btntext2">照片直播</div>
          <div class="btntext btnhide">/</div>
          <div class="btnimgout">
            <img src="../../assets/images/ccdslineimg.png" class="btnmimg2" />
          </div>
        </div>
      </div>

      <div class="btnrow">
        <div class="btn111" @click="gocontact()">
          <div class="btntext111">联系我们</div>
          <div class="btntext btnhide">/</div>
          <div class="btnimgout">
            <img src="../../assets/images/ccdsctimg.png" class="btnmimg111" />
          </div>
        </div>
        <!-- <div class="btn50" @click="gozn()">
          <div class="btntext2">智能客服</div>
          <div class="btntext btnhide">/</div>
          <div class="btnimgout">
            <img src="../../assets/images/ccdsznimg.png" class="btnmimg2" />
          </div>
        </div> -->
      </div>
    </div>
    <div class="tcout" v-if="showtc == 1">
      <div class="tcimg">
        <div class="jumptc" @click="gotcurl(list.LinkUrl, list.Id, list.Description)">
          <img :src="list.ImgUrl" class="tcimgin" />
        </div>
        <div class="close" @click="closebtn()">
          <img src="../../assets/images/tcclose.png" class="tcimgin" />
        </div>
      </div>

      <div class="back"></div>
    </div>
  </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
export default {
  name: 'CCDS',
  data() {
    return {
      day: 0,
      hh: 0,
      mm: 0,
      ss: 0,
      list: {},
      showtc: 0,
      isopen: 0,
      bannerlist: [],
    }
  },
  mixins: [mixin],
  components: {
  },
  created() {
    this.getimg();
    this.count();
    this.getlunbo();
    this.initccdsShare();
    document.title = "CCDS第四届中国皮肤外科大会";
  },
  methods: {
    gotcurl(u, id, d) {
      if (u) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: d,
            TCode: 'activity_link',
            Rid: id,
          },)
          .then((res) => {
            window.location.href = u;
          });
      }
    },
    getimg() {
      let that = this
      let isClose = sessionStorage.getItem("acmedLinkClose");
      if (!isClose) {
        this.$axios.post('/api/api/web/activity/GetActivityLink', {
          Code: "CCDSIndex",
        }).then(res => {
          // console.log(res.data.Data)
          if (res.Data.length > 0) {
            that.showtc = 1
            that.list = res.Data[0]
          } else {
            that.showtc = 0
          }
          // console.log(this.list)
        })
      }
    },
    getlunbo() {
      let that = this
      this.$axios.post('/api/api/web/activity/GetActivityBanner', {
        Code: "CCDSIndex",
      }).then(res => {
        // console.log(res.data.Data)
        if (res.Data) {
          that.bannerlist = res.Data
        }
        // console.log(this.list)
      })
    },
    gowelcome() {
      this.$router.push({ name: 'ccdswelcome' })
    },
    goregmeeting() {
      this.$router.push({ name: 'ccdsregmeeting' })
    },
    goinfo() {
      this.$router.push({ name: 'ccdsinfo' })
    },
    gobaseinfo() {
      this.$router.push({ name: 'baseinfo' })
    },
    gozuzhi() {
      this.$router.push({ name: 'ccdszuzhi' })
    },
    gocontact() {
      this.$router.push({ name: 'ccdscontact' })
    },
    gotimeline() {
      this.$router.push({ name: 'ccdstimeline' })
    },
    gojoinme() {
      this.$router.push({ name: 'ccdsjoinmeeting' })
    },
    gozn() {
      this.$router.push({ name: 'ccdszhineng' })
    },
    gozb() {
      // this.$router.push({ name: 'ccdszhibo' })
      window.location.href = "https://www.pailixiang.com/m/album/main_ig99041521.html"
    },
    gojiaotong() {
      this.$router.push({ name: 'ccdsjiaotong' })
    },
    godownfile() {
      this.$router.push({ name: 'ccdsdownfile' })
    },
    goToExternalLink() {
      window.location.href = 'https://mp.weixin.qq.com/s/q0HTpYzezGgwvYKXciYOtw';
    },
    closebtn() {
      this.showtc = 0;
      sessionStorage.setItem("acmedLinkClose", "1");
    },
    count() {
      // 设置倒计时的结束时间为未来某个时间
      var endTime = new Date("2025/9/13 08:00:00");
      let that = this
      // 每秒执行一次
      setInterval(function () {
        // 获取当前时间和结束时间的时间差
        var nowTime = new Date();
        var timeDiff = endTime.getTime() - nowTime.getTime();

        // 计算剩余时间
        var days = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
        var hours = Math.floor((timeDiff / 1000 / 60 / 60) % 24);
        var minutes = Math.floor((timeDiff / 1000 / 60) % 60);
        var seconds = Math.floor((timeDiff / 1000) % 60);
        that.ss = seconds;
        that.hh = hours;
        that.day = days;
        that.mm = minutes;
        // 将剩余时间显示在页面上
        if (timeDiff <= 0) {
          that.isopen = 1;
        }
        // var countdownDiv = document.getElementById("countdown");
        // countdownDiv.innerHTML = "距离2024年元旦还有：" + days + "天" + hours + "小时" + minutes + "分" + seconds + "秒";
        // console.log("距离还有：" + this.day + "天" + hours + "小时" + minutes + "分" + this.ss + "秒")
      }, 1000);
    },
    jumpimgurl(url, id, d) {
      if (url) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: d,
            TCode: 'activity_banner',
            Rid: id,
            UpId: '4'
          })
          .then((res) => {
            window.location.href = url;
          });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  width: 100%;
  background: rgb(228, 236, 255);
  position: relative;
}

.img {
  display: block;
  width: 100%;
  margin-bottom: .2rem
}

.guanggaoimg {
  display: block;
  width: 92%;
  margin: auto;
  margin-bottom: .2rem;
  padding-top: 0.3rem;
}

.btnlist {
  display: flex;
  flex-direction: column;
  width: 92%;
  margin: auto;
}

.btnrow {
  display: flex;
  flex-direction: row;
  margin-bottom: .2rem;
}

.btnmiddle {
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  width: 33%;
  border-radius: 5px;
  padding: .2rem 0;
  box-shadow: -1px 1px 1px 1px rgba(0, 0, 0, 0.1);
  margin-right: .2rem;
  display: flex;
  flex-direction: column;
}

.btnmiddleleft {
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  width: 33%;
  border-radius: 5px;
  padding: .3rem 0;
  box-shadow: -1px 1px 1px 1px rgba(0, 0, 0, 0.1);
  margin-left: .2rem;
}

.btnmimg {
  display: block;
  width: 22%;
  margin: auto;
  margin-right: 10%;
}

.btnimgout {
  text-align: right;
  width: 100%;
}

.btntext {
  display: block;
  width: 100%;
  font-size: .4rem;
  color: #ffd7c0;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 10%;
}

.btnlarge {
  display: flex;
  flex-direction: column;
  width: 66%;
  background-image: linear-gradient(to right, #003583, #003bb9);
  box-shadow: 0 0.026667rem 0.133333rem 0 rgba(0, 0, 0, 0.1);
  border-radius: 0.133333rem;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0;
}

.left50 {
  margin-right: 2%
}

.btn50 {
  display: flex;
  flex-direction: column;
  width: 49%;
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0;
}

.btn111 {
  display: flex;
  flex-direction: row;
  width: 100%;
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0;
}

.btnmimg1 {
  display: block;
  width: 11%;
  margin: auto;
  margin-right: 5%;
}

.btnmimg2 {
  display: block;
  width: 14%;
  margin: auto;
  margin-right: 7%;
}

.btnmimg111 {
  display: block;
  width: 21%;
  margin: auto;
  margin-right: 13%;
}

.btntext1 {
  display: block;
  width: 100%;
  font-size: .4rem;
  color: #ffd7c0;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 5%;
}

.btntext2 {
  display: block;
  width: 100%;
  font-size: .4rem;
  color: #ffd7c0;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 7%;
}

.btntext111 {
  display: block;
  width: 100%;
  font-size: .4rem;
  color: #ffd7c0;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 4%;
}

.btnincol {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  top: 0;
  justify-content: space-between;
  height: 100%;
}

.btnsmall {
  display: flex;
  flex-direction: row;
  width: 100%;
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.11rem 0;
  position: relative;
  margin-top: 0.1rem;
}

.btnsmall1 {
  display: flex;
  flex-direction: row;
  width: 100%;
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  // padding: 0.18rem 0;
}

.btnsmall2 {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.05rem 0;
  // position: absolute;
  // left: 0;
  // top: 0;
  color: #ffd7c0;
  // font-weight: bold;
}

.timem {
  font-size: .4rem;
}

.times {
  font-size: .4rem;
}

.timel {
  font-size: 0.6rem;
  font-weight: bold;
}

.btnsimple {
  position: relative;
  width: 100%;
}

.btnincolnew {
  position: unset;
}

.btnheng {
  flex-direction: row;
}

.tcout {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 20;

  .tcimg {
    display: block;
    width: 80%;
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
    z-index: 30;

    .close {
      width: 1rem;
      height: 1rem;
      display: block;
      margin: auto;
      margin-top: 0.2rem;
    }

    img {
      display: block;
      width: 100%;
    }
  }

  .back {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 25;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
  }
}

// .jumptc {}

.btnhide {
  opacity: 0;
  font-size: .2rem;
}

.btnhide1 {
  opacity: 0;
  font-size: .8rem;
}

.bold {
  display: inline-block;
  font-weight: bold;
}

.bannerimg {
  width: 100%;
  display: block;
}

.elbanner {
  position: relative;
  height: 4.15rem;
  width: 93%;
  margin: auto;
  overflow: hidden;
  padding-top: .3rem;
}

::v-deep .el-carousel__container {
  height: 100%;
}

::v-deep .el-carousel__indicators--horizontal {
  bottom: 5%;
}
</style>